﻿export const SHOW_ALERT = (state, parameters) => {
    state.alertModal = parameters;
    state.alertModal.show = true;
};

export const UPDATE_ALERT = (state, data) => {
    state.alertModal = data;
};

export const HIDE_ALERT = (state) => {
    state.alertModal = Object.assign({}, state.alertModal);
    state.alertModal.show = false;
};

export const IS_BAD_PAYER = (state, bool) => {
    state.customer.badPayer = bool;
};

export const UPDATE_BASKET = (state, basketDetails) => {
    state.basket.content = basketDetails;
};

export const REGISTER_BASKET = (state, blockId) => {
    state.basket.id = blockId;
};

export const VALIDATE_FORM_BLOCK = (state, block) => {
    const newform = state.form;
    newform[block.index] = block;
    state.form = [];
    state.form = newform;
};

export const REGISTER_FORM_BLOCK = (state, block) => {
    state.form.push(block);
};

export const UPDATE_CUSTOMER = (state, customer) => {
    state.customer = customer;
};

export const EXISTING_CUSTOMER_BLOCK_ACTIVE = (state, bool) => {
    state.existingCustomerBlockActive = bool;
};

export const VALIDATE_CUSTOMER_DATA = (state, bool) => {
    state.customerDataValidated = bool;
};

export const IS_EXISTING_CUSTOMER = (state, bool) => {
    state.customer.existingCustomer = bool;
};

